import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { SidebarMenu } from '@gef-ui/material/components/Sidebar';

import { HideOnPrint } from 'components';

import ExternalLinks from './ExternalLinks';
import InternalLinks from './InternalLinks';

export const LeftMenu = ({ onClick }) => (
	<HideOnPrint>
		<SidebarMenu sx={{ p: 0 }}>
			<Box
				sx={{
					overflowY: 'scroll',
					'::-webkit-scrollbar': {
						width: 10,
					},
					'::-webkit-scrollbar-track': {
						background: 'transparent',
					},
					'::-webkit-scrollbar-thumb': {
						background: (theme) => theme.palette.grey[300],
						padding: 0,
					},
					maxHeight: 'calc(100vh - 85px)',
					overflowX: 'hidden',
					p: 2,
				}}
			>
				<InternalLinks onItemClick={onClick} />
				<ExternalLinks />
			</Box>
		</SidebarMenu>
	</HideOnPrint>
);

LeftMenu.propTypes = {
	onClick: PropTypes.func,
};

export default LeftMenu;
